import { Icon } from '@livable/saas-react-components';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import FinancialTextInput from 'src/components/shared/FinancialTextInput';
import useStyles from './styles';
export const CAP = observer(_ref => {
  let capName = _ref.capName,
    capInputLabel = _ref.capInputLabel,
    capDescription = _ref.capDescription,
    capInfoMark = _ref.capInfoMark,
    capValue = _ref.capValue,
    handleChange = _ref.handleChange;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.utility
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coins-in-hand"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, capName || 'Some CAP'), !!(capDescription !== null && capDescription !== void 0 && capDescription.length) && /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, capDescription))), /*#__PURE__*/React.createElement("div", {
    className: classes.inputField
  }, /*#__PURE__*/React.createElement(FinancialTextInput, {
    handleInputChange: handleChange,
    infoMark: capInfoMark,
    inputLabel: capInputLabel || 'CAP Amount',
    valueExt: capValue,
    withAdorment: true
  })));
});